import { render, staticRenderFns } from "./PlanCardPrice.vue?vue&type=template&id=18302527&scoped=true"
import script from "./PlanCardPrice.vue?vue&type=script&lang=js"
export * from "./PlanCardPrice.vue?vue&type=script&lang=js"
import style0 from "./PlanCardPrice.vue?vue&type=style&index=0&id=18302527&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18302527",
  null
  
)

export default component.exports